import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="border-t border-red-900/20 bg-black mt-auto">
      <div className="container mx-auto px-4 py-8">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div className="space-y-3">
            <div className="flex items-center gap-2">
              <img 
                src="/logo.png" 
                alt="Deadline by Daria" 
                className="h-8 w-auto"
                style={{ 
                  mixBlendMode: 'screen'
                }}
              />
            </div>
            <p className="text-sm text-gray-400 font-typewriter">
              Unravel the Mysteries.
            </p>
          </div>

          <div>
            <h3 className="font-semibold mb-3 text-amber-500">Platform</h3>
            <ul className="space-y-2 text-sm">
              <li><Link to="/tiers" className="text-gray-400 hover:text-amber-500 transition-colors">Subscription Tiers</Link></li>
              <li><Link to="/feed" className="text-gray-400 hover:text-amber-500 transition-colors">Posts</Link></li>
            </ul>
          </div>

          <div>
            <h3 className="font-semibold mb-3 text-amber-500">Support</h3>
            <ul className="space-y-2 text-sm">
              <li><Link to="/help-centre" className="text-gray-400 hover:text-amber-500 transition-colors">Help Centre</Link></li>
              <li><a href="mailto:deadlinebydaria@gmail.com" className="text-gray-400 hover:text-amber-500 transition-colors">Contact Us</a></li>
            </ul>
          </div>

          <div>
            <h3 className="font-semibold mb-3 text-amber-500">Legal</h3>
            <ul className="space-y-2 text-sm">
              <li><Link to="/terms" className="text-gray-400 hover:text-amber-500 transition-colors">Terms of Service</Link></li>
              <li><Link to="/privacy" className="text-gray-400 hover:text-amber-500 transition-colors">Privacy Policy</Link></li>
              <li><Link to="/content-policy" className="text-gray-400 hover:text-amber-500 transition-colors" data-testid="footer-content-policy-link">Content Policy</Link></li>
            </ul>
          </div>
        </div>

        <div className="border-t border-amber-900/20 mt-8 pt-8 text-center text-sm text-gray-500">
          <p>&copy; 2025 DEADLINE by Daria. All rights reserved. Mature themes — ages 18+.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;